import { Stepper, Step, StepLabel, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomStepIcon = styled('div')(({ ownerState }) => ({
  backgroundColor: ownerState.active || ownerState.completed ? '#166534' : '#cbd5e1',
  color: '#fff',
  width: 32,
  height: 32,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
}));

const StepIconComponent = (props) => {
  const { active, completed, icon } = props;
  return <CustomStepIcon ownerState={{ active, completed }}>{icon}</CustomStepIcon>;
};

export default function StepperHeader({ steps, activeStep }) {
  return (
    <Box
      className="default-bg-color"
      sx={{
        width: '100%',
        px: 0,
        py: 3,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', px: 4 }}>
        <Stepper activeStep={activeStep} sx={{ width: '100%' }}>
          {steps.map((step) => (
            <Step key={step.title}>
              <StepLabel StepIconComponent={StepIconComponent}>
                <span style={{ fontWeight: 500 }}>{step.title}</span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
}
